import { PANELS } from 'constants/event_type_editor_panels'
import { CrudNotificationsSurface, EventTypeEditorPanels } from 'features/event_type_editor'

import {
  AVAILABILITY_TAB_KEY,
  AvailabilityTabPanel,
} from './availability'
import { QuestionsTab, BOOKING_PAGE_TAB_KEY } from './booking_page'
import { ConfirmationTab } from './confirmation'
import { MeetingDetailsTab } from './meeting_details/meeting_details_tab'
import { PAYMENTS_TAB_KEY, PaymentsTab } from './payments'
import { DEFAULT_TAB_KEY, getDefaultEventTypeEditorCrudTab, getEventTypeEditorCrudTab } from './registry'
import {
  SCHEDULING_LIMITS_TAB_KEY,
  SchedulingLimitsPanel,
} from './scheduling_limits'

const NOTIFICATIONS_TAB_KEY = 'notifications'

export const ActiveTabPanels = ({
  tabKey,
  etLocks = {},
  lockingDisables = false,
  panelKeys,
  panelPropsByKey = {}
}) => {
  const activeTab = getEventTypeEditorCrudTab(tabKey) || getDefaultEventTypeEditorCrudTab()
  const activePanelKeys = panelKeys || activeTab.panelKeys

  const renderActiveTabPanel = () => {
    if (activeTab.key === NOTIFICATIONS_TAB_KEY) {
      return <CrudNotificationsSurface />
    }

    if (activeTab.key === 'confirmation') {
      return <ConfirmationTab isLocked={etLocks[PANELS.confirmationPage]} />
    }

    if (activeTab.key === AVAILABILITY_TAB_KEY) {
      return (
        <AvailabilityTabPanel
          isLocked={Boolean(etLocks[PANELS.availability])}
          isReadOnly={Boolean(panelPropsByKey[PANELS.availability]?.isReadOnly)}
        />
      )
    }

    if (activeTab.key === BOOKING_PAGE_TAB_KEY) {
      return <QuestionsTab isLocked={etLocks[PANELS.inviteeForm]} />
    }

    if (activeTab.key === SCHEDULING_LIMITS_TAB_KEY) {
      return <SchedulingLimitsPanel isLocked={Boolean(etLocks.limitsAndBuffers)} />
    }

    if (activeTab.key === DEFAULT_TAB_KEY) {
      return (
        <MeetingDetailsTab
          etLocks={etLocks}
          lockingDisables={lockingDisables}
        />
      )
    }

    return (
      <EventTypeEditorPanels
        panelKeys={activePanelKeys}
        etLocks={etLocks}
        lockingDisables={lockingDisables}
        panelPropsByKey={panelPropsByKey}
        submitOnPanelToggle={false}
      />
    )
  }

  if (activeTab.key === PAYMENTS_TAB_KEY) {
    return (
      <div
        data-testid="active-tab-panels"
        data-active-tab={activeTab.key}
      >
        <PaymentsTab isLocked={Boolean(etLocks[PANELS.payment])} />
      </div>
    )
  }

  return (
    <div
      data-testid="active-tab-panels"
      data-active-tab={activeTab.key}
    >
      {renderActiveTabPanel()}
    </div>
  )
}
